import $ from 'jquery';

const homepage = () => {
    const mainBanner = $('.home .main-banner');

    if (mainBanner.length > 0) {
        mainBanner.owlCarousel({
            items: 1,
            dots: true,
            nav: true,
            autoplay: true,
            loop: true,
            autoplaySpeed: 1000
        })
    }
}

export default homepage;
